export const iconFontAwesomeMaritimeOtter = (
	<i className="fa-solid fa-otter"></i>
);
